//const qs = require('querystring');
import ClientMessageView from "../components/dialogs/view/ClientMessageView.vue";
import PasswordInfos from "../components/utils/PasswordInfos.vue";
import { DateHelper } from "../utils/objects";
import { OneSignalSetup } from "../utils/OneSignalSetup";
import { cookieManager, isValid } from "../utils/utilitiesmodule";

let tokenLoginInProgress = false;

export default {
    name: "Login",
    components: {
        "ClientMessageView": ClientMessageView,
        PasswordInfos,
    },
    data() {
        return {
            loading: true,
            userlogin: {
                username: null,
                password: null,
                rememberme: false,
                resetToken: ''
            },
            step: 0,

            STEP_LOGIN:0,
            STEP_RESET_PWD_USERNAME:1,
            STEP_RESET_PWD_PASSWORD:2,
            eulaUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'eula.aspx',
            privacyUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'privacy-gdpr.aspx?lang=en',
            contactUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'contact.aspx',
        };
    },
    props: {
        reset: { type: String, default: null },
        msg: String,
        code: String
    },
    computed: {
        isResetPasswordValid() {
            const password = this.userlogin.password || '';
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\s])(?!.*\s).{8,50}$/.test(password);
        }
    },
    beforeRouteLeave(to, from, next) {
        //console.log(`Navigato da ${from.path} a ${to.path}`);
        if (this.$root.authObj || to.name == 'login2FA') {
            next()
        } else {
            next(false)
        }
    },
    beforeDestroy: function () {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
    },
    beforeCreate() {
        //console.log(this.$route);
    },
    created: function () {

        /*console.log('[login] location.search:', window.location.search);
        console.log('[login] $route.fullPath:', this.$route.fullPath);
        console.log('[login] $route.query:', this.$route.query);

        const reset = this.$route.query.reset;
        if (reset) {
        this.handleReset(reset);
        const { reset, ...rest } = this.$route.query;
        this.$router.replace({ path: this.$route.path, query: rest });
        }*/

        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        //this.$root.newPage("login", "created");
        this.$store.commit('SET_LAYOUT', 'simple-layout');
        if (this.$root.checkConnectionTimer != null) {
            clearInterval(this.$root.checkConnectionTimer);
        }
        this.$root.checkConnectionTimer = null;
        this.$root.closeSocket()
    },
    mounted: async function () {

        // accesso ad iperiusONE con token come ad esempio da remote.iperius.com o da software client desktop
        const loginToken = this.getLoginTokenFromLocation();
        if (loginToken) {
            if (tokenLoginInProgress) {
                return;
            }

            tokenLoginInProgress = true;
            this.clearLoginTokenFromLocation();

            const tokenAuth = await this.$api.loginWithToken(loginToken);

            try {
                if (await this.handleAuthResult(tokenAuth, false, "otp")) {
                    return;
                }
            } finally {
                tokenLoginInProgress = false;
            }
        }

        if (this.$route.query.reset) {
            this.userlogin.resetToken = this.$route.query.reset;
            this.$api.validateToken(this.userlogin.resetToken).then(async (response) => {
                if (response?.status == 200) {
                    this.step = this.STEP_RESET_PWD_PASSWORD;
                }
            });
        }

        //this.$root.newPage("login", "mounted");
        this.$session.setRoomPC(null);


        //Se nella richiesta dell'auth code:
        //response_mode == fragment -> this.$route.hash è una stringa che contiene 'code='
        //response_mode == query -> this.$route.query.code è l'authCode


        if (!isValid(this.$route.query)) {
            this.loading = false;
            return;
        }

        //Caso 1 : Durante la procedura di creazione di un service account di tipo 10 (Google Drive) o di tipo 13 (Onedrive),
        //è stata effettuata la richiesta per l'authorization code.

        if (isValid(this.$route.query.code)) {
            cookieManager.setCookie("authCode", this.$route.query.code);
            close();
        }

        //Caso 2 : Durante la procedura di creazione di un service account di tipo 13 (Onedrive),
        //è stata effettuata la richiesta per convalidare i permessi dell'applicazione appena registrata sulla piattaforma di Azure
        if (isValid(this.$route.query.admin_consent) && this.$route.query.admin_consent == "True") {
            cookieManager.setCookie("admin_consent", this.$route.query.admin_consent == "True");
            close();
        } /* */



        if (this.$root.authObj != null) {

            this.$store.commit('SET_LAYOUT', 'nav-layout')

            // QUESTE FUNZIONI VENGONO CHIAMATE ANCHE QUI PERCHè A LOGIN.JS MOUNTED IL CODICE TORNA NEL CASO DI LOGIN 2FA

            // LEGGE I MODULI RELATIVI ALLA LICENZA
            //await this.getLicensesExtendedInfos();
            // [GT - 31/07/2025 ] SE HA SOLO REMOTE VA ALLA DASHBOARD DI REMOTE
            //if (this.checkisOnlyRemoteLicensingState()) {
            //    this.$router.replace('/remotestats');
            //}else{
            this.$router.replace('/dashboard');
            //}    
        }

        //aspetto che il service worker sia attivo per poter utilizzare le notifiche push con un setlistener
        setTimeout(() => {
            OneSignalSetup.handleWebPushChange();
        }, 2000);

        // vue non attende che questo metodo sia completato per fare il rendering dell'html, perchè l'ho modificato in async per aspettare getLicensesExtendedInfos()
        // per evitare che per un istante si veda la pagina di login uso una variabile per nascondere la pagina fino a quando questo metodo non è andato a termine
        this.loading = false;

    },

    methods: {

        async login() {
            const authObj = await this.$api.login(this.userlogin.username, this.userlogin.password);
            await this.handleAuthResult(authObj, this.userlogin.rememberme, "standard");
        },

        getLoginTokenFromLocation() {
            if (this.$route.query.token) {
                return this.$route.query.token;
            }

            const hash = window.location.hash.startsWith('#')
                ? window.location.hash.slice(1)
                : window.location.hash;

            if (!hash) {
                return null;
            }

            const hashParams = new URLSearchParams(hash);
            return hashParams.get('token') || hashParams.get('access_token');
        },

        clearLoginTokenFromLocation() {
            if (!window.history?.replaceState) {
                return;
            }

            const url = new URL(window.location.href);

            url.searchParams.delete('token');
            url.searchParams.delete('access_token');

            if (url.hash) {
                const hash = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash;
                const hashParams = new URLSearchParams(hash);

                hashParams.delete('token');
                hashParams.delete('access_token');

                const cleanHash = hashParams.toString();
                url.hash = cleanHash ? `#${cleanHash}` : '';
            }

            window.history.replaceState(null, document.title, `${url.pathname}${url.search}${url.hash}`);
        },

        async handleAuthResult(authObj, rememberme = false, loginMode = "standard") {
            if (authObj == null) {
                return false;
            }
            if (authObj.dataora_scadenza) {
                const expirationDate = DateHelper.parseUtc(authObj.dataora_scadenza);
                authObj.licenceExpired = expirationDate != null && expirationDate.isBefore();
            } else if (authObj.licenceExpired == undefined) {
                authObj.licenceExpired = false;
            }


            switch (authObj.message) {
                case "Require2FA":
                    if (loginMode == "otp") {
                        sessionStorage.setItem("LOGIN_2FA_MODE", "otp");
                    } else {
                        sessionStorage.removeItem("LOGIN_2FA_MODE");
                    }
                    this.$root.authObj = null;
                    if (this.$route.name != 'login2FA') {
                        await this.$router.replace("/login2FA").catch((error) => {
                            if (error?.name != "NavigationDuplicated") {
                                throw error;
                            }
                        });
                    }
                    return true;

                case "LicenseExpired":

                    authObj.username = this.userlogin.username;
                    authObj.licenceExpired = true;

                    this.$root.authObj = authObj;
                    this.$session.setAuth(this.$root.authObj);
                    localStorage.setItem("AUTH", JSON.stringify(this.$root.authObj));
                    this.$root.login(rememberme);

                    return true;

                case null:
                case undefined:
                    this.$root.authObj = authObj;
                    sessionStorage.removeItem("LOGIN_2FA_MODE");
                    this.$root.login(rememberme);
                    return true;

                default:
                    this.$root.authObj = null;
                    return false;
            }
        },

        // [GT - 31/07/2025 ] CHIAMATA API PER LEGGERE TUTTE LE LICENZE E I MODULI PRESENTI NELLA LICENZA
        // VALORIZZA VARIABILE DI SESSIONE "LICENSES"
        /*async getLicensesExtendedInfos(){

            let self = this;

            const ext_lic_info= await self.$api.getLicenseExtendedInfo();

            if (ext_lic_info!=null) {
                this.$session.setLicenses(ext_lic_info);
            }
        },*/

        // [GT - 31/07/2025 ] LEGGENDO IL JSON DI LICENSES, NELLA SESSIONE, CONTROLLA CHE ABBIA SOLO LA LICENZA DI REMOTE
        /*checkisOnlyRemoteLicensingState() {

            const licenses = this.$session.getLicenses();

            if (!licenses) {
                console.warn("Licenze non trovate");
                return false;
            }

            const { backup, monitoring, remote } = licenses;
            return remote.length > 0 && backup.length === 0 && monitoring.length === 0;
        },*/

        async resetpwd() {
            let self = this;
            self.$api.resetpwd(self.userlogin.username).then(async (ok) => {
                if (ok) {
                    //console.log(response);
                    self.$root.toast(self.$t("Mail sent, check your mailbox and click on the reset link."), "success")
                    self.step = this.STEP_LOGIN;
                }
            });
        },

        async sendNewPassword() {
            if (!this.isResetPasswordValid) return;

            let self = this;
            self.$api.sendNewPassword(self.userlogin.resetToken, self.userlogin.password).then(async (response) => {
                if (response?.status == 200) {
                    //console.log(response);
                    self.$root.toast(self.$t("Password changed successfully."), "success")
                    self.step = this.STEP_LOGIN;
                }
            });
        }
    }
};
